<template>
  <div class="current-bar" :style="currentBarStyle" />
</template>

<script lang="ts">
import { Temporal } from '@js-temporal/polyfill'
import { TIME_LINE_HOUR_WIDTH } from '@/src/lib/constants'

export default defineComponent({
  props: {
    time: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const currentBarStyle = computed<{ left: string }>(() => {
      const hours = Temporal.PlainTime.from(props.time).since('00:00').total({ unit: 'hours' })
      return {
        left: `${hours * TIME_LINE_HOUR_WIDTH}px`,
      }
    })
    return { currentBarStyle }
  },
})
</script>

<style scoped lang="scss">
.current-bar {
  background-color: rgb(228, 173, 173);
  display: block;
  height: calc(100% - 40px);
  position: absolute;
  width: 1px;
}
</style>
